const initialState = {
    competition: {
        id: 0
    },
    optin: {
        submitted: false,
        submitting: false,
        error: false,
        payload: {}
    },
    vote: {
        payload: {
            idVote: 0,
            statisticsDefenders: [],
            statisticsMidfielders: [],
            statisticsForwards: []
        },
        share: {
            submitted: false,
            submitting: false,
            data: [],
        }
        // payload: {
        //     "errorCode": "0",
        //     "message": "Vote persisted.",
        //     "idVote": 19,
        //     "statisticsDefenders": [{
        //         "firstname": "Kieran",
        //         "lastname": "COLLINS",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/12-KieranCOLLINS-small.jpg",
        //         "percent": 16.666666
        //     }, {
        //         "firstname": "Marcus",
        //         "lastname": "ADAMS",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/7-MarcusADAMS-small.jpg",
        //         "percent": 15.789474
        //     }, {
        //         "firstname": "Shane",
        //         "lastname": "BIGGS",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/8-ShaneBIGGS-small.jpg",
        //         "percent": 15.789474
        //     }],
        //     "statisticsMidfielders": [{
        //         "firstname": "Zaine",
        //         "lastname": "CORDY",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/13-ZaineCORDY-small.jpg",
        //         "percent": 16.666666
        //     }, {
        //         "firstname": "Hayden",
        //         "lastname": "CROZIER",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/14-HaydenCROZIER-small.jpg",
        //         "percent": 16.666666
        //     }, {
        //         "firstname": "Tory",
        //         "lastname": "DICKSON",
        //         "headshotSmall": "https://benchvote.s3.amazonaws.com/bulldogs-headshots/18-ToryDICKSON-small.jpg",
        //         "percent": 16.666666
        //     }],
        //     "statisticsForwards": [{
        //         "firstname": "Mitch",
        //         "lastname": "HONEYCHURCH",
        //         "headshotSmall":
        // "https://benchvote.s3.amazonaws.com/bulldogs-headshots/23-MitchHONEYCHURCH-small.jpg", "percent": 16.666666
        // }, { "firstname": "Tom", "lastname": "LIBERATORE", "headshotSmall":
        // "https://benchvote.s3.amazonaws.com/bulldogs-headshots/27-TomLIBERATORE-small.jpg", "percent": 16.666666 },
        // { "firstname": "Fergus", "lastname": "GREENE", "headshotSmall":
        // "https://benchvote.s3.amazonaws.com/bulldogs-headshots/22-FergusGREENE-small.jpg", "percent": 16.666666 }] }
    },
    dynamicRender: {
        dynamicSubmitted: false,
        dynamicSubmitting: false,
        dynamicRenderUrl: ''
    },
    globalScript: {
        globalScriptFetched: false,
        globalScriptData: {}
    }
};

export default (state = initialState, action) => {

    switch (action.type) {
    case 'LOAD_COMP_START':
        return {
            ...state,
            competition: {}
        }
    case 'LOAD_COMP_FINISH':
        return {
            ...state,
            competition: action.payload.data
        }
    case 'LOAD_COMP_ERROR':
        let success = action.payload.errorCode === "0" ? true : false;

        return {
            ...state,
            competition: {}
        }
    case 'SUBMIT_START':
        return {
            ...state,
            vote: {
                submitted: false,
                submitting: true,
                error: false,
                payload: {
                    idVote: 0,
                    statisticsDefenders: [],
                    statisticsMidfielders: [],
                    statisticsForwards: []
                }
            }
        }
    case 'SUBMIT_FINISH':

        return {
            ...state,
            vote: {
                submitted: true,
                submitting: false,
                error: false,
                payload: action.payload
            }
        }
    case 'SUBMIT_ERROR':
        return {
            ...state,
            vote: {
                submitted: false,
                submitting: false,
                error: true,
                payload: {
                    idVote: 0,
                    statisticsDefenders: [],
                    statisticsMidfielders: [],
                    statisticsForwards: []
                }
            }
        }
    case 'OPTIN_START':
        return {
            ...state,
            optin: {
                submitted: false,
                submitting: true,
                error: false,
                payload: {}
            }
        }
    case 'OPTIN_FINISH':

        return {
            ...state,
            optin: {
                submitted: true,
                submitting: false,
                error: false,
                payload: action.payload
            }
        }
    case 'OPTIN_ERROR':
        return {
            ...state,
            vote: {
                submitted: false,
                submitting: false,
                error: true,
                payload: {}
            }
        }
    case 'RENDER_SHARE_START':
        return {
            ...state,
            vote: {
                ...state.vote,
                share: {
                    submitted: false,
                    submitting: true,
                    data: [],
                }
            }
        }
    case 'RENDER_SHARE_FINISH':
        console.log("RENDER_SHARE_FINISH", action.payload)
        return {
            ...state,
            vote: {
                ...state.vote,
                share: {
                    submitted: true,
                    submitting: false,
                    data: action.payload && action.payload.enabledSocialNetworks,
                }
            }
        }
    case 'DYNAMIC_RENDER_START':
        return {
            ...state,
            dynamicRender: {
                dynamicSubmitted: false,
                dynamicSubmitting: true,
                dynamicRenderUrl: ''
            }
        }
    case 'DYNAMIC_RENDER_FINISH':
        console.log("DYNAMIC_RENDER_FINISH", action.payload);
        return {
            ...state,
            dynamicRender: {
                dynamicSubmitted: true,
                dynamicSubmitting: false,
                dynamicRenderUrl: action.payload && action.payload.dynamicRenderUrl,
            }
        }
    case 'GET_GLOBAL_SCRIPTS_START':
        return {
            ...state,
            globalScript: {
                globalScriptFetched: false,
                globalScriptData: {}
            }
        }
    case 'GET_GLOBAL_SCRIPTS_FINISH':
        console.log("GET_GLOBAL_SCRIPTS_FINISH", action.payload.data);
        return {
            ...state,
            globalScript: {
                globalScriptFetched: true,
                globalScriptData: action.payload && action.payload.data
            }
        }
    default:
        return state
    }
}
